<ng-container *ngIf="shippings && shippings.length > 0">
  <collapse
    class="collapse-content"
    *ngFor="let shipping of shippings; trackBy: trackByIndex"
    attr.aria-label="Cerrar shipping"
    role="button">
    <div class="collapse-header">
      <div
        class="shipping-header-ee-icon"
      >
        <span class="shipping-header-ee-icon-default shipping-header-ee-icon-mm-{{shipping.dbcode}}"></span>
      </div>
      <div class="shipping-header-ee-description">
        <p>{{ shipping.name }}</p>
        <p
          *ngIf="shipping?.promotions && shipping?.promotions?.length > 0"
          class="shipping-header-ee-description-mm-green"
        > {{ getPromotion(shipping) }}</p>
      </div>
    </div>
    <div class="collapse-body">
      <p class="shipping-body-ee-price">{{ shipping.price }}</p>
      <p class="shipping-body-ee-text">{{ shipping.description }}</p>
    </div>
  </collapse>
</ng-container>
